import Contact from "../components/Contact";
import Header from "../components/Header";


export default function ContactPages(){
    return(<div>
        <Header/>
        <Contact/>
 </div>   )
}